export enum VisibilityEnum {
  HIDDEN = 'HIDDEN',
  VISIBLE = 'VISIBLE',
}
